import { useEffect, useRef } from "react";
import { useUser } from "../hooks/useUser";
import { BottomNav } from "../components/BottomNav";
import { ReflectionCard } from "../components/ReflectionCard";
import { QuickActions } from "../components/QuickActions";
import { HeaderAvatars } from "../components/HeaderAvatars";

function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
}

export function HomePage() {
  const { data: user, isLoading } = useUser();

  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    scrollRef.current?.scrollTo(0, 0);
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen-safe flex items-center justify-center bg-[#F8F8F6]">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-brand-primary border-t-transparent" />
      </div>
    );
  }

  const userName = user?.name || "there";
  const partnerName = user?.partner_name || "your partner";
  const userInitial = userName[0]?.toUpperCase() || "?";
  const partnerInitial = partnerName[0]?.toUpperCase() || "?";

  // Find conversations by type
  const oneOnOne = user?.conversations?.find(c => c.type === "1on1");
  const group = user?.conversations?.find(c => c.type === "group");

  const chatLink = oneOnOne?.chat_link || "";
  const groupChatLink = group?.chat_link || "";
  const partnerJoined = !!group;

  return (
    <div className="min-h-screen-safe bg-[#F8F8F6] flex flex-col">
      {/* Main content area */}
      <div ref={scrollRef} className="flex-1 overflow-y-auto">
        <div className="max-w-md mx-auto w-full px-4 py-6 pb-32">
          {/* Header */}
          <header className="flex items-center justify-between pt-8 mb-6">
            {partnerJoined ? (
              <HeaderAvatars
                userInitial={userInitial}
                partnerInitial={partnerInitial}
                partnerJoined
                onInviteClick={() => undefined}
              />
            ) : (
              <div className="w-9 h-9" />
            )}

            {/* Center: Greeting */}
            <span className="font-serif text-lg text-[#1a1a1a]">{getGreeting()}</span>

            {/* Right: Placeholder */}
            <div className="w-9 h-9" />
          </header>

          {/* Sections */}
          <div className="space-y-8">
            {!partnerJoined && <ReflectionCard />}
            {partnerJoined && (
              <QuickActions
                partnerName={partnerName}
                chatLink={chatLink}
                groupChatLink={groupChatLink}
                onInviteClick={() => undefined}
              />
            )}
          </div>
        </div>
      </div>

      {/* Bottom nav - fixed to viewport bottom */}
      <div className="fixed bottom-0 left-0 right-0 z-40">
        <div className="max-w-md mx-auto w-full">
          <BottomNav />
        </div>
      </div>
    </div>
  );
}
